<template>
  <div id="about">
    <Banner
      v-if="lifts['about:hero']"
      :lift="lifts['about:hero']"
    />
    <Slogan
      class="py-5"
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:slogan']"
      :lift="lifts['about:slogan']"
    />
    <Slogans :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"/>
    <Story
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:story']"
      :lift="lifts['about:story']"
    />
    <Formula
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:formula']"
      :lift="lifts['about:formula']"
    />
    <LatestDescription
      class="py-4"
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:latest']"
      :lift="lifts['about:latest']"
    />

    <base-container tag="section">
      <div>
        <Categories :categories="categories"/>
      </div>
    </base-container>

    <Story
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:search']"
      :lift="lifts['about:search']"
    />
    <!-- artzie -->
    <section
      :class="{'py-5': $vuetify.breakpoint.mdAndUp}"
    >
      <ArtzieBox/>
    </section>

    <Story
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:favorite']"
      :lift="lifts['about:favorite']"
      right
    />

    <Experience
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:experience']"
      :lift="lifts['about:experience']"
    />
    <Story
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:article']"
      :lift="lifts['about:article']"
    />
    <PostList
      class="pb-5"
      :class="{'mt-2': $vuetify.breakpoint.mdAndUp}"
      v-if="lifts['about:newsletter'] || lifts['about:register']"
      :posts="{
        newsletter: lifts['about:newsletter'],
        register: lifts['about:register'],
      }"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Banner from './Banner.vue'
import { usePreferenceStore } from '@/components/Domain/Reference/usePreferenceStore'
import Story from './Story.vue'
import Slogan from './Slogan.vue'
import Slogans from './Slogans.vue'
import Formula from './Formula.vue'
import LatestDescription from './LatestDescription.vue'
import Latest from '../Home/Latest.vue'
import ArtzieBox from '../../components/Domain/Artzie/ArtzieBox.vue'
import Experience from './Experience.vue'
import PostList from './PostList.vue'
import Categories from '../../components/Domain/Category/Categories.vue'

export default Vue.extend({
  name: 'About',
  components: { Categories, PostList, Experience, ArtzieBox, Latest, LatestDescription, Formula, Slogans, Story, Banner, Slogan },
  data () {
    return {
      lifts: {},
      categories: [],
    }
  },

  methods: {
    async fetchLifts () {
      const { getMap, fetchItems, getCategories } = usePreferenceStore()
      await fetchItems()
      this.lifts = getMap()
      this.categories = getCategories()
    },
    getLift (component, key) {
      return (this.lifts[component] || {})[key]
    }
  },

  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    },
    heroAspectRatio () {
      if (this.isMobile) return 0.93
      return 2.5
    },

  },

  mounted () {
    this.fetchLifts()
  },

})
</script>

<style
  scoped
  lang="scss"
>

</style>
